import { render } from "./UserDashboard.vue?vue&type=template&id=61c58896&scoped=true&lang=pug"
import script from "./UserDashboard.vue?vue&type=script&lang=js"
export * from "./UserDashboard.vue?vue&type=script&lang=js"

import "./UserDashboard.vue?vue&type=style&index=0&id=61c58896&lang=scss&scoped=true"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61c58896"]])

export default __exports__